export const APP_NAME = 'gig_page_perseus';
export const GIG_PAGE_CLIENT = {
    name: 'gig_page_client',
};

export const ROUTE_KEYS = {
    GET_LOYALTY_POINTS: 'calculate_potential_loyalty_points',
};
